module.exports = __webpack_public_path__ + "img/mainPage-icon1.5bcf4f0e.png";